<script>
	import MultiSelect from "./MultiSelect.svelte";
	import stores from "../stores/storeStore";
	import { createEventDispatcher } from "svelte";

	export let tags = [];
	export let readonly = false;

	const dispatch = createEventDispatcher();

	let tagValues = [];
	let tagOptions = [];

	const handleChange = async (e) => {
		dispatch("change");
	};

	const addTag = async (e) => {
		let t = e.detail.value;
		tags.push({ label: t, value: t });
	};

	const removeTag = async (e) => {
		let t = e.detail.value;
		let indexToRemove = tags.findIndex((t) => t.value == t);
		tags.splice(indexToRemove, 1);
	};

	const initialise = async () => {
		if (tags) {
			tagValues = tags.map((t) => t.value);
		}

		tagOptions = $stores.map((t) => ({ name: t.label, value: t.value }));
	};
</script>

{#await initialise()}
	<p>... loading outlets</p>
{:then}
	{#if $stores}
		<MultiSelect
			{readonly}
			placeholder="Start typing"
			bind:value={tagValues}
			options={tagOptions}
			on:change={(e) => handleChange(e)}
			on:remove={(e) => removeTag(e)}
			on:add={(e) => addTag(e)}>
			{#each $stores as tag, i (tag)}
				<option value={tag.value}>{tag.label}</option>
			{/each}
		</MultiSelect>
	{/if}
{/await}

<style>
	@keyframes shake {
		0% {
			transform: translate(7px);
		}
		20% {
			transform: translate(-7px);
		}
		40% {
			transform: translate(3px);
		}
		60% {
			transform: translate(-3px);
		}
		80% {
			transform: translate(1px);
		}
		100% {
			transform: translate(0px);
		}
	}
</style>
